package tta.destinigo.talktoastro.feature_call_consultation.domain

import kotlinx.coroutines.flow.Flow
import kotlinx.coroutines.flow.flow
import tta.destinigo.talktoastro.feature_call_consultation.data.api.QueueApiServiceImplementation
import tta.destinigo.talktoastro.feature_call_consultation.data.request.JoinQueueRequest
import tta.destinigo.talktoastro.feature_call_consultation.data.request.RemoveQueueRequest
import tta.destinigo.talktoastro.feature_call_consultation.data.request.ValidateQueueRequest
import tta.destinigo.talktoastro.feature_call_consultation.data.response.join_queue.JoinQueueData
import tta.destinigo.talktoastro.feature_call_consultation.data.response.join_queue.QueueStatusRequest
import tta.destinigo.talktoastro.feature_call_consultation.domain.mapper.toQueueStatusUiData
import tta.destinigo.talktoastro.feature_call_consultation.domain.model.QueueStatusUiData
import tta.destinigo.talktoastro.feature_call_consultation.domain.model.QueueValidationStatus
import tta.destinigo.talktoastro.shared.remote.Resources

class QueueRepo(
    private val api: QueueApiServiceImplementation
) {

    fun validateQueue(request: ValidateQueueRequest): Flow<Resources<QueueValidationStatus>>{
        return flow {
            emit(Resources.Loading())
            val response = api.validateQueueStatus(request)
            if (response is Resources.Error || (response as Resources.Success).data == null){
                emit(Resources.Error(response.msg))
            }else{
                emit(Resources.Success(data = QueueValidationStatus(
                    isValidationPassed = true,
                    validationMessage = response.msg.toString()
                )))
            }
        }
    }

    fun getQueueStatus(request: QueueStatusRequest): Flow<Resources<QueueStatusUiData>>{
        return flow {
            emit(Resources.Loading())
            val response = api.getQueueStatus(request)
            if (response is Resources.Error || (response as Resources.Success).data == null){
                emit(Resources.Error(response.msg))
            }else{
                emit(Resources.Success(response.data?.first()?.toQueueStatusUiData()))
            }
        }
    }

    fun joinQueue(joinQueueRequest: JoinQueueRequest):Flow<Resources<JoinQueueData>>{
        return flow {
            emit(Resources.Loading())
            val response = api.onJoinQueue(joinQueueRequest)
            if (response is Resources.Error || (response as Resources.Success).data == null){
                emit(Resources.Error("Join Queue Unable to Call , Reason -> ${response.msg}"))
            }else{
              emit(Resources.Success(response.data))
            }
        }
    }


    fun removeQueue(removeQueueRequest: RemoveQueueRequest): Flow<Resources<String>>{
        return flow {
            emit(Resources.Loading())
            val response = api.onRemoveQueue(removeQueueRequest)
            if (response is Resources.Error || (response as Resources.Success).data == null){
                emit(Resources.Error(response.msg))
            }else{
                emit(Resources.Success(response.data))
            }
        }
    }
}